import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PatientDashboardTabComponent } from 'src/app/patients/dashboard-page/dashboard-tab/dashboard-tab.component';
import { PatientDashboardStore } from 'src/app/patients/state/dashboard-page.store';
import { TabsModule } from 'primeng/tabs';
import { NursingOrdersTabComponent } from './nursing-orders-tab/nursing-orders-tab.component';
import { ProviderOrdersTabComponent } from './provider-orders-tab/provider-orders-tab.component';
import { HistoryAndPhysicalTabComponent } from './history-and-physical-tab/history-and-physical-tab.component';
import { ProgressNotesTabComponent } from './progress-notes-tab/progress-notes-tab.component';
import { OrderSetsTabComponent } from './order-sets-tab/order-sets-tab.component';

@Component({
  selector: 'app-provider-charts-tab',
  templateUrl: './provider-charts-tab.component.html',
  styleUrls: ['./provider-charts-tab.component.scss'],
  standalone: true,
  imports: [
    TabsModule,
    NursingOrdersTabComponent,
    ProviderOrdersTabComponent,
    HistoryAndPhysicalTabComponent,
    ProgressNotesTabComponent,
    OrderSetsTabComponent,
  ],
})
export class ProviderChartsTabComponent extends PatientDashboardTabComponent implements OnInit {
  constructor(patientStore: PatientDashboardStore, store: Store) {
    super(patientStore, store);
  }
}
